import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const jacketCoverShape = ImmutablePropTypes.mapContains({
  type: PropTypes.string,
  smallCover: PropTypes.string,
  mediumCover: PropTypes.string,
  largeCover: PropTypes.string,
  localUrl: PropTypes.string
});

const bibListItemShape = ImmutablePropTypes.mapContains({
  id: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  authors: ImmutablePropTypes.listOf(PropTypes.string),
  format: PropTypes.string,
  pubYear: PropTypes.string
});

const urlListItemShape = ImmutablePropTypes.mapContains({
  url: ImmutablePropTypes.mapContains({
    title: PropTypes.string,
    url: PropTypes.string
  })
});

const listItemShape = ImmutablePropTypes.mapContains({
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  bibListItem: bibListItemShape,
  jacketCover: jacketCoverShape,
  urlListItem: urlListItemShape,
  annotation: PropTypes.string,
  isDraft: PropTypes.bool
});

export default listItemShape;
